/**
 * 内容管理
 * @Description: 内容管理模块路由及完整子路由
 *
 * @Author: JZT.lmy
 * @Date: 2019-02-20 11:37:21
 * @Last Modified by: JZT.lmy
 * @Last Modified time: 2019-02-20 15:48:50
 */

export default [
    {
        path: "/contentManage/seckill",
        name: "秒杀专题配置",
        component: () => import("@/pages/contentManage/seckill/SecKillConfig"),
        icon: "none",
        meta: {
            comName: "SecKillConfigList",
            needRefresh: true
        }
    },
    {
        path: "/contentManage/seckill/add",
        name: "秒杀专题新增",
        component: () =>
            import("@/pages/contentManage/seckill/SecKillConfigAdd"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "SecKillConfigAdd"
        }
    },
    {
        path: "/contentManage/seckill/edit",
        name: "秒杀专题编辑",
        component: () =>
            import("@/pages/contentManage/seckill/SecKillConfigEdit"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "SecKillConfigEdit"
        }
    },
    {
        path: "/contentManage/seckill/det",
        name: "秒杀专题详情",
        component: () =>
            import("@/pages/contentManage/seckill/SecKillConfigDet"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "SecKillConfigDet"
        }
    },
    {
        path: "/contentManage/homeConfig",
        name: "平台首页配置",
        component: () => import("@/pages/contentManage/homeConfig/HomeConfig"),
        icon: "none",
        meta: {
            comName: "homeConfig",
            needRefresh: true
        }
    },
    {
        path: "/contentManage/homeConfig/slider",
        name: "平台首页banner配置",
        component: () => import("@/pages/contentManage/homeConfig/HomeSlider"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "homeConfigSlider"
        }
    },
    {
        path: "/contentManage/homeConfig/wing",
        name: "平台首页翅膀配置",
        component: () => import("@/pages/contentManage/homeConfig/HomeWing"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "homeConfigWing"
        }
    },
    {
        path: "/contentManage/homeConfig/hotword",
        name: "平台首页热词配置",
        component: () => import("@/pages/contentManage/homeConfig/HomeHotWord"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "homeConfigHotWord"
        }
    },
    {
        path: "/contentManage/homeConfig/nav",
        name: "平台首页导航配置",
        component: () => import("@/pages/contentManage/homeConfig/HomeNav"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "homeConfigNav"
        }
    },
    {
        path: "/contentManage/homeConfig/picfloor",
        name: "平台首页图片楼层配置",
        component: () =>
            import("@/pages/contentManage/homeConfig/HomePicFloor"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "homeConfigPicFloor"
        }
    },
    {
        path: "/contentManage/homeConfig/topad",
        name: "平台首页顶部广告配置",
        component: () => import("@/pages/contentManage/homeConfig/HomeTopAd"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "homeConfigTopAd"
        }
    },
    {
        path: "/contentManage/homeConfig/prodfloor",
        name: "平台首页商品楼层配置",
        component: () =>
            import("@/pages/contentManage/homeConfig/HomeProdFloor"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "homeConfigProdFloor"
        }
    },
    {
        path: "/contentManage/themematicPageConfig",
        name: "自定义专题页",
        component: () =>
            import("@/pages/contentManage/themematicPageConfig/ThemematicPageConfig"),
        icon: "none",
        meta: {
            comName: "themematicPageConfig",
            needRefresh: true
        }
    },
    {
        path: "/contentManage/themematicPageConfig/newThemePage",
        name: "自定义专题页配置",
        component: () =>
            import("@/pages/contentManage/themematicPageConfig/newThemePage"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "newThemePage"
        }
    },
    {
        path: "/contentManage/categoryGoods",
        name: "标品类目管理",
        component: () => import("@/pages/contentManage/categoryGoods/index"),
        icon: "none",
        meta: {
            comName: "categoryGoodsList",
            needRefresh: true
        }
    },
    {
        path: "/contentManage/categoryGoods/categoryConfig",
        name: "导航分类配置",
        component: () =>
            import("@/pages/contentManage/categoryGoods/categoryConfig"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "categoryGoodsCategoryConfig",
            needRefresh: true
        }
    },
    {
        path: "/contentManage/miniAppBannerConfig/miniAppBanner",
        name: "小程序Banner配置",
        component: () =>
            import("@/pages/contentManage/miniAppBannerConfig/miniAppBanner"),
        icon: "none",
        meta: {
            comName: "miniAppBanner",
            needRefresh: true
        }
    }
];



// WEBPACK FOOTER //
// ./src/router/content.js